export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';
export const GET_CENTERS = 'GET_CENTERS';
export const API_HOST = 'https://webtools.au.dk';
